export const TypeScriptTasks = [
  {
    id: 'ts-pick',
    categoryId: '5',
    title: 'Pick',
    code: `interface Todo {
  id: string
  title: string
  description: string
  completed: boolean
  createdAt: number
}

type SimpleTodo = Pick<Todo, 'id' | 'title' | 'completed'>

const todo1: SimpleTodo = {
  id: '111',
  title: 'Learn React',
  completed: true,
}`,
    lang: 'ts',
  },
  {
    id: 'ts-interface',
    categoryId: '5',
    title: 'interface',
    code: `interface Employee {
  firstName: string
  lastName: string
  fullName(): string
}

let employee: Employee = {
  firstName: 'Emil',
  lastName: 'Anderson',
  fullName() {
    return \`\${this.firstName} \${this.lastName}\`
  },
}`,
    lang: 'ts',
  },
  {
    id: 'ts-omit',
    categoryId: '5',
    title: 'Omit',
    code: `interface Todo {
  id: string
  title: string
  description: string
  completed: boolean
  createdAt: number
}

type TodoInfo = Omit<Todo, "completed" | "createdAt">

const todoInfo: TodoInfo = {
  title: "Pick up kids",
  description: "Kindergarten closes at 5pm",
}`,
    lang: 'ts',
  },
  {
    id: 'ts-enum',
    categoryId: '5',
    title: 'enum',
    code: `enum Direction {
  North = 'NORTH',
  South = 'SOUTH',
  East = 'EAST',
  West = 'WEST'
}

let wayToArcticOcean: Direction
wayToArcticOcean = Direction.North`,
    lang: 'ts',
  },
  {
    id: 'ts-narrowing',
    categoryId: '5',
    title: 'narrowing',
    code: `const printAll = (strs: string | string[] | null) => {
  if (strs && typeof strs === 'object') {
    for (const s of strs) {
      console.log(s)
    }
  } else if (typeof strs === 'string') {
    console.log(strs)
  }
}`,
    lang: 'ts',
  },
  {
    id: 'ts-in-narrowing',
    categoryId: '5',
    title: 'in operator narrowing',
    code: `type Fish = { swim: () => void }
type Bird = { fly: () => void }

function move(animal: Fish | Bird) {
  if ('swim' in animal) {
    return animal.swim()
  }

  return animal.fly()
}`,
    lang: 'ts',
  },
  {
    id: 'ts-generic',
    categoryId: '5',
    title: 'generic',
    code: `type Collection<T> = {
  name: string,
  quantity: number,
  content: T[]
}

const bookCollection: Collection<string> = {
  name: 'Nursery Books',
  quantity: 3,
  content: ['Goodnight Moon', 'Humpty Dumpty', 'Green Eggs & Ham']
}`,
    lang: 'ts',
  },
  {
    id: 'ts-class',
    categoryId: '5',
    title: 'class',
    code: `class Person {
  private name: string
  private age: number

  constructor(name: string, age: number) {
    this.name = name
    this.age = age
  }

  toString(): string {
    return \`\${this.name} (\${this.age})\`
  }
}`,
    lang: 'ts',
  },
]
